// @ts-ignore
import Docs from "./preset.mdx"

export default Docs as React.FC
